import {
  Block,
  Button,
  ButtonGroup,
  Card,
  Col,
  Filters,
  filterUrlParamName,
  Icon,
  Menu,
  MenuItem,
  Row,
  SelectBox,
  serializeFilter,
  Space,
  StringInput,
  Table,
  TableColumn,
  Text,
  Title,
} from "@mc/ui-v4";
import { Link } from "react-router-dom";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { BaseLayoutWrapper } from "../components/BaseLayoutWrapper";
import React, { useMemo } from "react";
import { formatCurrency } from "@mc/react-format";
import { useQuery } from "react-query";
import {
  KeKontroleEnum,
  RekapitulaceRadekVO,
  RekapitulaceVO,
  SoudniSporyApi,
} from "../api";
import { REKAPITULACE, ROKY } from "../queryKeys";
import { WaitForQueryData } from "@mc/react-app-v4";
import { useHistory } from "react-router";
type kontrolaType = {
  keKontroleExterni: number;
  keKontroleRentabilita: number;
  keKontroleVlastni: number;
  koeficientExterni: number;
  koeficientRentabilita: number;
  koeficientVlastni: number;
};
export const HomePage: React.FC = () => {
  const defaultRok = Number(localStorage.getItem("rok")) || null;
  const [rok, setRok] = React.useState<number>(defaultRok);
  const [vyhledatText, setVyhledatText] = React.useState("");
  const History = useHistory();
  const RekapitulaceQuery = useQuery<RekapitulaceVO>(
    [REKAPITULACE, rok],
    async () => (await SoudniSporyApi.getRekapitulace(rok)).data,
      {enabled: rok !== null}
  );
  const RokyQuery = useQuery<number[]>(
    [ROKY],
    async () => (await SoudniSporyApi.getRekapitulaceRoky()).data
  );
  React.useEffect(() => {
    console.log(RokyQuery?.data,"RokyQuery?.data");
    console.log(defaultRok,"defaultRok");
    if (RokyQuery?.data?.length > 0) {
      if (!defaultRok || !RokyQuery.data.includes(defaultRok)) {
        setRok(Math.max(...RokyQuery?.data));
      }
    }
  }, [RokyQuery.data]);
  const vyhledat = () => {
    History.push(
      `/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter({
        fulltext: vyhledatText,
      })}`
    );
  };
  return (
    <BaseLayoutWrapper currentKey={"home"}>
      <WaitForQueryData queries={[RekapitulaceQuery, RokyQuery]}>
        {() => {
          const data = RekapitulaceQuery.data;
          console.log("render",RekapitulaceQuery,RokyQuery)
          if (!data) return undefined;
          const roky = RokyQuery.data;
          const {
            radky,
            keKontroleVlastni,
            keKontroleExterni,
            keKontroleRentabilita,
            koeficientExterni,
            koeficientRentabilita,
            koeficientVlastni,
          } = data;
          //hack aby šli data použít do tabulky kvůli stejnému vzhledu
          const constrolaData: kontrolaType = {
            keKontroleVlastni: keKontroleVlastni || 0,
            keKontroleRentabilita: keKontroleRentabilita || 0,
            keKontroleExterni: keKontroleExterni || 0,
            koeficientExterni: koeficientExterni || 0,
            koeficientRentabilita: koeficientRentabilita || 0,
            koeficientVlastni: koeficientVlastni || 0,
          };

          return (
            <Space className={"w-75 pl-4 pt-3"} vertical size={"3"}>
              <Title level={1}>Přehled soudních sporů</Title>
              <Card mode={"edit"}>
                <Block>
                  <Row>
                    <Col>
                      <StringInput
                        onKeyDown={(e) => {
                          //if e.key is enter
                          if (e.key === "Enter" && vyhledatText?.length > 0) {
                            vyhledat();
                          }
                        }}
                        onChange={(event) =>
                          setVyhledatText(event.target?.value)
                        }
                        placeholder={
                          "Zadejte typ/druh sporu, subjekt (stranu sporu) nebo spisovou značku"
                        }
                      />
                    </Col>
                    <Col xs={"auto"}>
                      <Button
                        onClick={() => {
                          if (vyhledatText?.length > 0) {
                            vyhledat();
                          }
                        }}
                      >
                        Vyhledat
                      </Button>
                    </Col>
                  </Row>
                </Block>
              </Card>
              <Space className={"d-flex align-items-center"} size={"2"}>
                <Title level={2}>Rekapitulace</Title>
                {roky?.length > 0 && (
                  <>
                    {/*<Button
                      popupWindowProps={{}}
                      menu={
                        <Menu>
                          {roky
                            .flatMap((i) => Array(8).fill(i))
                            ?.map((rok) => (
                              <MenuItem
                                onClick={() => {
                                  setRok(rok);
                                  localStorage.setItem("rok", rok.toString());
                                }}
                                text={`Rok ${rok}`}
                              />
                            ))}
                        </Menu>
                      }
                    >
                      rok {rok}
                    </Button>*/}
                    <div
                      className={"d-flex align-items-center"}
                      style={{ width: "135px" }}
                    >
                      <Title className={"pr-1"} intent={"primary"} level={3}>
                        rok
                      </Title>
                      <SelectBox
                        value={rok}
                        onChange={(value) => {
                          setRok(value);
                          localStorage.setItem("rok", value.toString());
                        }}
                        getItemId={(rok) => rok}
                        getItemName={(rok) => rok?.toString()}
                        items={roky}
                      />
                    </div>
                  </>
                )}
                <Button
                  title={
                    "Rok dle soudní značky, pokud zatím není vyplněna, pak je zařazeno dle data zápisu do AGENDIO"
                  }
                  style={"link"}
                  icon={<Icon icon={faInfoCircle} />}
                />
              </Space>
              <Space size={"2"} className={"w-100 d-flex"}>
                <SporyTable rok={rok} radky={radky} />
                <KontrolaTable rok={rok} data={[constrolaData]} />
              </Space>
            </Space>
          );
        }}
      </WaitForQueryData>
    </BaseLayoutWrapper>
  );
};

type SporyTableProps = {
  radky: RekapitulaceRadekVO[];
  rok: number;
};

const SporyTable: React.FC<SporyTableProps> = ({ radky, rok }) => {
  const columns: TableColumn<RekapitulaceRadekVO>[] = useMemo(() => {
    return [
      {
        nazevTypPripad: "typDoklad",
        header: "Spor",
        cell: ({ row }) => {
          return (
            <Space>
              <Title level={1}>{row.nazevTypPripad}</Title>
            </Space>
          );
        },
        footer: () => {
          return (
            <Title intent={"inactive"} level={1}>
              {"Celkem"}
            </Title>
          );
        },
      },

      {
        header: "Vlastní zastoupení",
        align: "right",
        cell: ({ row }) => {
          return row.pocetVlastni > 0 ? (
            <Link
              className={"d-flex justify-content-end"}
              to={`/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter(
                { zastoupeni: "INTERNI", idTypSporu: row.idTypPripad, rok: rok }
              )}`}
            >
              <Title level={1}>{row?.pocetVlastni}</Title>
            </Link>
          ) : (
            <Title
              className={"d-flex justify-content-end"}
              intent={"inactive"}
              level={1}
            >
              {row?.pocetVlastni}
            </Title>
          );
        },
        footer: () => {
          const total = React.useMemo(
            () => radky.reduce((sum, row) => row.pocetVlastni + sum, 0),
            [radky]
          );
          if (total > 0) {
            return (
              <Link
                className={"d-flex justify-content-end"}
                to={`/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter(
                  { zastoupeni: "INTERNI", rok: rok }
                )}`}
              >
                <Title level={1}>
                  <Text strong>{total}</Text>
                </Title>
              </Link>
            );
          }
          return (
            <Title
              className={"d-flex justify-content-end"}
              intent={"inactive"}
              level={1}
            >
              <Text strong>{total}</Text>
            </Title>
          );
        },
      },
      {
        header: "Externí advokát",
        align: "right",
        cell: ({ row }) => {
          return row.pocetExterni > 0 ? (
            <Link
              className={"d-flex justify-content-end"}
              to={`/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter(
                { zastoupeni: "EXTERNI", idTypSporu: row.idTypPripad, rok: rok }
              )}`}
            >
              <Title level={1}>{row?.pocetExterni}</Title>
            </Link>
          ) : (
            <Title
              className={"d-flex justify-content-end"}
              intent={"inactive"}
              level={1}
            >
              {row?.pocetExterni}
            </Title>
          );
        },
        footer: () => {
          const total = React.useMemo(
            () => radky.reduce((sum, row) => row.pocetExterni + sum, 0),
            [radky]
          );
          if (total > 0) {
            return (
              <Link
                className={"d-flex justify-content-end"}
                to={`/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter(
                  { zastoupeni: "EXTERNI", rok: rok }
                )}`}
              >
                <Title level={1}>
                  <Text strong>{total}</Text>
                </Title>
              </Link>
            );
          }
          return (
            <Title className={"d-flex justify-content-end"} level={1}>
              <Text strong>{total}</Text>
            </Title>
          );
        },
      },
      {
        header: "Celkem",
        align: "right",
        cell: ({ row }) => {
          if (row.pocetExterni + row.pocetVlastni > 0) {
            return (
              <Link
                className={"d-flex justify-content-end"}
                to={`/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter(
                  { idTypSporu: row.idTypPripad, rok: rok }
                )}`}
              >
                <Title level={1}>{row?.pocetExterni + row?.pocetVlastni}</Title>
              </Link>
            );
          }
          return (
            <Title
              className={"d-flex justify-content-end"}
              intent={"inactive"}
              level={1}
            >
              {0}
            </Title>
          );
        },
        footer: () => {
          const total = React.useMemo(
            () =>
              radky.reduce(
                (sum, row) => row.pocetExterni + row.pocetVlastni + sum,
                0
              ),
            [radky]
          );
          if (total > 0) {
            return (
              <Link
                className={"d-flex justify-content-end"}
                to={`/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter(
                  { rok: rok }
                )}`}
              >
                <Title level={1}>
                  <Text strong>{total}</Text>
                </Title>
              </Link>
            );
          }
          return (
            <Title className={"d-flex justify-content-end"} level={1}>
              <Text strong>{total}</Text>
            </Title>
          );
        },
      },
    ];
  }, [radky]);

  return (
    <Card className={"border flex-grow-1"} mode={"view"}>
      <Block className={"story-table-container"}>
        <Table
          className={"w-100 home-page-table"}
          columns={columns}
          data={radky}
        />
      </Block>
    </Card>
  );
};
type KontrolaTableProps = {
  data: kontrolaType[];
  rok: number;
};
const KontrolaTable: React.FC<KontrolaTableProps> = ({ data, rok }) => {
  const getKontrolaUrl = (keKontrole: KeKontroleEnum): string => {
    return `/soudni-spory/seznam/?${filterUrlParamName}=${serializeFilter({
      keKontrole: keKontrole,
    })}`;
  };
  const columns: TableColumn<kontrolaType>[] = useMemo(() => {
    return [
      {
        header: "Spor",
        cell: () => {
          return <Title level={1}>{"Ke kontrole"}</Title>;
        },
      },

      {
        header: "Rentabilita",
        align: "right",
        cell: ({ row }) => {
          if (row.keKontroleRentabilita < 1) {
            return (
              <Title
                className={"d-flex justify-content-end"}
                intent={"inactive"}
                level={1}
              >
                {row?.keKontroleRentabilita}
              </Title>
            );
          }
          return (
            <Link
              className={"d-flex justify-content-end"}
              title={`...spory se zapsanou částkou hodnota sporu dle žaloby, zapsané náklady sporu přesáhly ${row.keKontroleRentabilita}% hodnota sporu dle žaloby.`}
              to={getKontrolaUrl(KeKontroleEnum.RENTABILITA)}
            >
              <Title level={1}>{row?.keKontroleRentabilita}</Title>
            </Link>
          );
        },
      },
      {
        header: "Externí náklady",
        align: "right",
        cell: ({ row }) => {
          if (row.keKontroleExterni < 1) {
            return (
              <Title
                className={"d-flex justify-content-end"}
                intent={"inactive"}
                level={1}
              >
                {row?.keKontroleExterni}
              </Title>
            );
          }
          return (
            <Link
              className={"d-flex justify-content-end"}
              title={`...spory se zapsanou částkou limit nákladů, zapsané náklady na externí právní zastoupení přesáhly ${row.koeficientExterni}% zadaného limitu nákladů na externího advokáta.`}
              to={getKontrolaUrl(KeKontroleEnum.EXTERNI)}
            >
              <Title level={1}>{row?.keKontroleExterni}</Title>
            </Link>
          );
        },
      },
      {
        header: "Náklady sporu celkem",
        align: "right",
        cell: ({ row }) => {
          if (row.keKontroleVlastni < 1) {
            return (
              <Title
                className={"d-flex justify-content-end"}
                intent={"inactive"}
                level={1}
              >
                {row?.keKontroleVlastni}
              </Title>
            );
          }
          return (
            <Link
              className={"d-flex justify-content-end"}
              title={`...spory se zapsanou částkou limit nákladů, celková výše zapsaných nákladů sporu přesáhla ${row.koeficientVlastni}% zadaného limitu.`}
              to={getKontrolaUrl(KeKontroleEnum.INTERNI)}
            >
              <Title level={1}>{row?.keKontroleVlastni}</Title>
            </Link>
          );
        },
      },
    ];
  }, [data]);

  return (
    <Card className={"border flex-grow-1 one-row-table"} mode={"view"}>
      <Block className={"story-table-container"}>
        <Table
          className={"w-100 home-page-table "}
          columns={columns}
          data={data}
        />
      </Block>
    </Card>
  );
};
